import React from 'react';

const CustomisedBanner = () => {
  return (
    <div className="services-banner backtesting-banner customised-banner">
      <div className="container">
        <div className="services-banner-wrapper">
          <h1>Customized Solution</h1>
          <p>
            Our Customized Solution service tailors trading strategies and tools
            to meet the unique needs and objectives of each trader.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CustomisedBanner;
